import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import useApiServices from "../../../../../../hooks/setting/useApiServices";
import ButtonStartIcon from "../../../../../button/ButtonStartIcon";
import ListApiServices from "./List/List";
import ApiServicesDialog from "./Dialog/Dialog";

const CredentialsApps = () => {
  const [modal, setModal] = useState(null);
  const permission = useSelector(
    (state) => state?.session?.permissions?.["api-and-services"] || {}
  );
  const list = useSelector((state) => state?.tenant?.apiServices || []);
  const { isLoadingList } = useApiServices();

  return (
    <>
      <Box className="bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8">
        <Typography variant="subtitle1" className="uppercase">
          API keys Credentials
        </Typography>
        {!isLoadingList && permission["created"] && (
          <ButtonStartIcon
            onClick={() => setModal({ type: "create", form: {} })}
            color="secondary"
            variant="contained"
            startIcon={["fas", "plus"]}
          >
            Create
          </ButtonStartIcon>
        )}
      </Box>
      <Box className="px-2 py-2">
        <ListApiServices
          list={list}
          isLoading={isLoadingList}
          permissions={permission}
          onModal={(type, form) => setModal({ type, form })}
        />
      </Box>
      {modal && (
        <ApiServicesDialog
          type={modal.type}
          show={!!modal}
          onClose={() => setModal(null)}
          data={modal.form || {}}
        />
      )}
    </>
  );
};

export default CredentialsApps;
